import instance, { ADMIN_PREFIX } from 'services/api';
import { FaqDetail, FaqInput, FaqListRow } from 'types/api/faq';

export interface FaqListResponse {
  data: FaqListRow[];
  total: number;
}

export interface FetchFaqListParams {
  page: number;
  limit: number;
  service_id?: number;
}

export const fetchFaqList = (params: FetchFaqListParams, lang: string) =>
  instance.get<FaqListResponse>(`${ADMIN_PREFIX}/content/faq`, {
    params,
    headers: { locale: lang }
  });

export const fetchFaqById = (id: string | number) =>
  instance.get<FaqDetail>(`${ADMIN_PREFIX}/content/faq/${id}`);

export const createFaq = (input: FaqInput) =>
  instance.post(`${ADMIN_PREFIX}/content/faq`, input);

export const updateFaq = (id: string | number, input: FaqInput) =>
  instance.put(`${ADMIN_PREFIX}/content/faq/${id}`, input);

export const deleteFaq = (id: string | number) =>
  instance.delete(`${ADMIN_PREFIX}/content/faq/${id}`);
